var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDokumenteTeilenImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 768 480",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-1",
    x1: "50%",
    x2: "50%",
    y2: "93.187%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F4FD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 480,
    display: "none",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 379.4 225.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    transform: "rotate(180 375.05 182.68)",
    d: "m749.2 365.08c0-255.72-118.44-364.8-374.15-364.8-255.72 0-374.15 109.08-374.15 364.8z",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 568,
    cy: 54.282,
    r: 10.8,
    fill: "#e5eeff",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 689.2,
    cy: 175.48,
    r: 7.2,
    fill: "#f2f5fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    transform: "rotate(150 276.4 17.082)",
    d: "m267.75 19.955c-2.3172-8.8588 8.4627-16.207 15.213-8.9594 6.75 7.2481-1.4104 17.415-10.075 14.496-1.8134-0.60401-2.6194 2.3154-0.80597 2.9194 11.687 3.926 21.761-10.268 12.996-19.53-8.7649-9.3621-23.373 0.10067-20.25 11.879 0.50374 1.9127 3.4254 1.1073 2.9216-0.80534z",
    fill: "#c4d2ed",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.402,
    cy: 242.68,
    r: 7.2,
    fill: "#d7dbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.2,
    cy: 59.082,
    r: 6,
    fill: "#d7dbe7"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(150 548.22 153.09)",
    d: "m539.57 155.96c-2.3172-8.8588 8.4627-16.207 15.213-8.9594 6.75 7.2481-1.4104 17.415-10.075 14.496-1.8134-0.604-2.6194 2.3154-0.80597 2.9194 11.687 3.926 21.761-10.268 12.996-19.53-8.7649-9.3621-23.373 0.10067-20.25 11.879 0.50373 1.9127 3.4254 1.1074 2.9216-0.80534z",
    fill: "#d9e4f7"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(135 146.8 331.48)",
    d: "m132.96 337.31c-4.9562-15.887 15.488-28.659 25.711-14.33 9.293 13.083-6.1953 28.348-19.515 21.494-5.266-2.8036-9.9125 5.2957-4.6465 8.0993 22.613 11.837 47.394-14.953 30.977-35.824-16.727-21.494-49.253-2.1806-41.509 23.052 1.8586 5.6072 10.842 3.4266 8.9832-2.4921z",
    fill: "#f3f6fe"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 640.81 155.06)",
    d: "m632.16 157.93c-2.3172-8.8588 8.4627-16.207 15.213-8.9594 6.75 7.2481-1.4104 17.416-10.075 14.496-1.8134-0.604-2.6194 2.3154-0.80598 2.9194 11.687 3.926 21.761-10.268 12.996-19.53-8.7649-9.3621-23.373 0.10067-20.25 11.879 0.50373 1.9127 3.4254 1.1074 2.9216-0.80534z",
    fill: "#f4f7fe"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "translate(397.7 240.4) scale(-1 1) rotate(-5) translate(-397.7 -240.4)",
    d: "m353.3 24.398 83.576 137.45-59.2 124.36 64.424 170.18",
    stroke: "#D3E6F4",
    strokeDasharray: 28.79999923706055,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.126 84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m206.03 34.556 3.0095 213.63v21.395c0 6.8925-5.5875 12.48-12.48 12.48h-184.08c-6.8925 0-12.48-5.5875-12.48-12.48v-230.81c0-3.4463 2.7937-6.24 6.24-6.24h0.065307l15.252 0.15998 42.42 0.8714",
    fill: "#fff",
    stroke: "#5374A5",
    strokeLinecap: "round",
    strokeWidth: 7.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "m194.04 46.567 2.6951 193.6v19.389c0 6.2463-5.0037 11.31-11.176 11.31h-164.85c-6.1724 0-11.176-5.0637-11.176-11.31v-208.65c0-3.4463 2.7937-6.24 6.24-6.24h20.393",
    fill: "#E2ECFF"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#5374A5",
    strokeWidth: 7.8
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.874 76)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x1: 4.3698e-13,
    x2: 134.16,
    y1: 1.56,
    y2: 1.56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.3698e-13,
    x2: 134.16,
    y1: 42.12,
    y2: 42.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.3698e-13,
    x2: 134.16,
    y1: 82.68,
    y2: 82.68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.3698e-13,
    x2: 60,
    y1: 160,
    y2: 160
  })), /*#__PURE__*/React.createElement("path", {
    d: "m179.97 3.9c2.2746 0 4.4562 0.90323 6.0651 2.5111l41.943 41.917c1.6102 1.6092 2.5149 3.7924 2.5149 6.0689v195.2c0 2.3693-0.96035 4.5143-2.513 6.067-1.5527 1.5527-3.6977 2.513-6.067 2.513h-184.08c-2.3693 0-4.5143-0.96035-6.067-2.513-1.5527-1.5527-2.513-3.6977-2.513-6.067v-237.12c0-2.3693 0.96035-4.5143 2.513-6.067 1.5527-1.5527 3.6977-2.513 6.067-2.513z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.35 7.4968v36.183c0 5.1694 4.1906 9.36 9.36 9.36h24.753",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.11 66.3c1.2821 0 2.5117 0.5091 3.4185 1.4154l29.36 29.342c0.90757 0.90701 1.4175 2.1375 1.4175 3.4206v136.64c0 1.3354-0.54129 2.5444-1.4164 3.4196-0.87514 0.87514-2.0841 1.4164-3.4196 1.4164h-128.86c-1.3354 0-2.5444-0.54129-3.4196-1.4164-0.87514-0.87514-1.4164-2.0841-1.4164-3.4196v-165.98c0-1.3354 0.54129-2.5444 1.4164-3.4196s2.0841-1.4164 3.4196-1.4164z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.874 92)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.8
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4.3698e-13,
    x2: 134.16,
    y1: 1.56,
    y2: 1.56,
    stroke: "#5374A5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.3698e-13,
    x2: 134.16,
    y1: 42.12,
    y2: 42.12,
    stroke: "#5374A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.3698e-13 82.68h77.376",
    stroke: "#79A3FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m396.07 67.648v25.328c0 3.6186 2.9334 6.552 6.552 6.552h17.327",
    stroke: "#5374A5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "m572.86 68.604 25.749 25.304c0.93668 0.92051 1.4643 2.1787 1.4643 3.492v136.82c0 3.8532-3.1236 6.9768-6.9768 6.9768h-122.47c-4.7219 0-8.5497-3.8951-8.5497-8.7v-161.07c0-2.3376 1.895-4.2326 4.2326-4.2326h16.142 86.981c1.2837 0 2.5161 0.50419 3.4317 1.404z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569.11 73.434 23.532 23.532c0.91818 0.91818 1.434 2.1635 1.434 3.462v127.8c0 3.8532-3.1236 6.9768-6.9768 6.9768h-112.34c-4.3523 0-7.8806-3.6534-7.8806-8.16v-150.81c0-2.3376 1.895-4.2326 4.2326-4.2326h14.547 79.992c1.2985 0 2.5438 0.51583 3.462 1.434z",
    fill: "#E2ECFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490.87 101.2)",
    stroke: "#5374A5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.7736
  }, /*#__PURE__*/React.createElement("line", {
    x2: 48,
    y1: 2.9547,
    y2: 2.9547
  }), /*#__PURE__*/React.createElement("line", {
    x2: 82.106,
    y1: 27.777,
    y2: 27.777
  }), /*#__PURE__*/React.createElement("line", {
    x2: 82.106,
    y1: 52.6,
    y2: 52.6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 36.72,
    y1: 99.92,
    y2: 99.92
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(457.27 62.4)",
    stroke: "#5374A5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m108.23 3.9c1.2821 0 2.5117 0.5091 3.4185 1.4154l29.36 29.342c0.90757 0.90701 1.4175 2.1375 1.4175 3.4206v136.64c0 1.3354-0.54129 2.5444-1.4164 3.4196-0.87514 0.87514-2.0841 1.4164-3.4196 1.4164h-128.86c-1.3354 0-2.5444-0.54129-3.4196-1.4164-0.87514-0.87514-1.4164-2.0841-1.4164-3.4196v-165.98c0-1.3354 0.54129-2.5444 1.4164-3.4196 0.87514-0.87514 2.0841-1.4164 3.4196-1.4164z",
    strokeWidth: 7.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.2 5.2478v25.328c0 3.6186 2.9334 6.552 6.552 6.552h17.327",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.46
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(417.6 -5489.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.288)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.203,
    cy: 5624.2,
    r: 29.203,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5942 .59424)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.48,
    cy: 5623,
    rx: 21.32,
    ry: 21.359,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 5623.5c0 14.072 11.408 25.48 25.48 25.48s25.48-11.408 25.48-25.48c-0.041139-14.055-11.425-25.439-25.48-25.48-14.072 0-25.48 11.408-25.48 25.48z",
    fill: "#5374A5",
    stroke: "#fff",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "449.17 146.2 449.17 122.31 440.33 123.17 440.33 126.1 445.18 126.1 445.18 146.2",
    fill: "#fff",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(592.8 105.6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.288)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.203,
    cy: 29.203,
    r: 29.203,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5942 3.5942)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.48,
    cy: 24.999,
    rx: 21.32,
    ry: 21.359,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.9278e-14 25.48c0 14.072 11.408 25.48 25.48 25.48s25.48-11.408 25.48-25.48c-0.041139-14.055-11.425-25.439-25.48-25.48-14.072 0-25.48 11.408-25.48 25.48z",
    fill: "#5374A5",
    stroke: "#fff",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m629.74 146.2v-3.1828h-10.762l-0.049218-0.098438 5.3156-5.6109c1.6188-1.7828 2.8137-3.2977 3.5848-4.5445 0.77109-1.2469 1.1566-2.5539 1.1566-3.9211 0-2.0453-0.66719-3.7023-2.0016-4.9711s-3.15-1.9031-5.4469-1.9031c-2.5156 0-4.4953 0.72461-5.9391 2.1738s-2.1383 3.2348-2.0836 5.3566l0.032813 0.098437h3.8555c0-1.3781 0.33906-2.4609 1.0172-3.2484s1.7172-1.1812 3.1172-1.1812c1.0609 0 1.9031 0.36094 2.5266 1.0828 0.62344 0.72188 0.93516 1.6188 0.93516 2.6906 0 0.85312-0.24062 1.7254-0.72188 2.6168s-1.3562 2.0316-2.625 3.4207l-7.7766 8.482v2.7398h15.865z",
    fill: "#fff",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,212)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.7736
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4.3698e-13,
    x2: 82.106,
    y1: 0.95472,
    y2: 0.95472,
    stroke: "#5374a5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.3698e-13,
    x2: 82.106,
    y1: 25.777,
    y2: 25.777,
    stroke: "#5374a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 50.6h47.354",
    stroke: "#79a3ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDokumenteTeilenImg);
export default __webpack_public_path__ + "static/media/Dokumente_teilen_img.47717c65cb80b79c7516eebe02fed0e2.svg";
export { ForwardRef as ReactComponent };